export enum SIDE_BAR_STATUS_ENUM {
  CLOSED = 'closed',
  OPEN = 'open',
}

export enum ORDER_CREATION_PACKAGE_TYPE {
  property = 'property',
  ads = 'ads',
  realtor = 'realtor',
  office = 'office',
}

export enum ORDER_STATUS {
  OPEN = 'open',
}
